export const API_KEY = '3429cba9cfdf4260bad090967567095a'
export const BASE_URL = 'https://api.themoviedb.org/3/'
export const IMG_URL = 'https://image.tmdb.org/t/p/original'
export const logoImg = 'https://upload.wikimedia.org/wikipedia/commons/thumb/0/08/Netflix_2015_logo.svg/1920px-Netflix_2015_logo.svg.png'
export const avatarImg = 'https://i.pinimg.com/originals/0d/dc/ca/0ddccae723d85a703b798a5e682c23c1.png'